import React, { useEffect } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@components/common/card";
import { Separator } from "@components/common/separator";
import { DictType } from "@pma/types";
import PmsLoader from "@components/common/loader";
import { Button } from "@components/common/button";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useAuth } from "@stores/auth-store";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import TaskCard from "../projects/task-card";
import useTranslator from "@hooks/use-translator";
import {
  SERVER_URL,
  TASK_BY_CURRENT_USER_ENDPOINT,
} from "@pma/utils/api-routes";
import axios from "axios";
import { parseCookies } from "nookies";
import { ACCESS_TOKEN } from "@pma/utils/constants";

const LatestTasks = () => {
  const { translate } = useTranslator();

  const { authConfig } = useAuth();
  const orgId = authConfig?.last_organization_id;

  const location = useLocation();
  const navigate = useNavigate();

  const [searchParam] = useSearchParams();
  const accessToken = parseCookies()[ACCESS_TOKEN];

  const queryKey = searchParam.get("revalidate");

  const getOrganizationTasks = async (pageParam: number) => {
    const response = await axios.post(
      SERVER_URL + TASK_BY_CURRENT_USER_ENDPOINT,
      {
        show_created_by: true,
        organization_id: orgId,
        paging_start_page: pageParam,
        paging_per_page: 10,
        show_deleted: false
      },
      {
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  };
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    status,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["get-tasks", orgId],
    queryFn: ({ pageParam = 1 }) => getOrganizationTasks(pageParam),

    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.nextPage) {
        return undefined;
      }
      return allPages?.length + 1;
    },
  });

  useEffect(()=>{


  },[data])

  const handleLoadMoreData = async () => {
    await fetchNextPage();
  };

  const isEmpty = !data?.pages[0]?.itemsReceived;

  useEffect(() => {
    if (queryKey === "tasks") {
      refetch();
      navigate(`${location.pathname}`);
    }
  }, [queryKey]);

  return (
    <Card className="h-[70vh] flex flex-col gap-2 items-center">
      <CardHeader className="border-b-2 border-primary">
        <CardTitle className="w-fit">{translate("Latest Tasks")}</CardTitle>
      </CardHeader>
      <Separator />
      <CardContent className="overflow-y-auto overflow-x-hidden flex flex-col w-full gap-3 px-2">
        {isLoading ? (
          <div style={{ width: "100%" }}>
            <PmsLoader />
          </div>
        ) : (
          <>
            {data &&
              data?.pages?.map((page) =>
                page?.items?.map((task: DictType) => (
                  <TaskCard task={task} key={task.id} />
                )),
              )}

            {isEmpty && !isFetching && (
              <small className="w-full h-full flex items-center justify-center">
                {translate("No Tasks found")}
              </small>
            )}
            {isFetchingNextPage && (
              <div style={{ width: "100%" }}>
                <PmsLoader />
              </div>
            )}
            {hasNextPage ? (
              <Button
                variant={"link"}
                className="text-primary"
                onClick={handleLoadMoreData}
              >
                {translate("Load More")}
              </Button>
            ) : null}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default LatestTasks;
